import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TImageField, TStringField } from '../../../types/sitecore.types';
import { TCardFields, TDashboardCardData, TProductLinesData, TProductLinesItemData } from '../types/cards.types';

export class CardsModel {
  /* eslint-disable-next-line */
  private readonly fields?: any;
  private readonly rendering?: ComponentRendering;
  private readonly itemData?: TProductLinesItemData;

  /* eslint-disable-next-line */
  constructor(props: any) {
    this.fields = props?.fields || undefined;
    this.rendering = props?.rendering;
    this.itemData = props?.fields?.itemData;
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): TStringField {
    return this.fields?.itemData?.fields?.lineListingTitle;
  }

  get cards(): TProductLinesData {
    return this.fields?.apiData;
  }

  get baseUrl(): string {
    return this.itemData?.contextItemUrl || '';
  }

  getProductDashBoardCardProps(item: TCardFields): TDashboardCardData {
    return {
      description: { value: item.description },
      title: { value: item.title },
      shortDescription: item?.shortDescription,
      productImageProps: {
        desktopRendition: item.assets?.[0]?.rendition_desktop_size500,
        mobileRendition: item.assets?.[0]?.rendition_mobile_size500,
        alt: item?.assets?.[0]?.alt,
      },
      titleUrl: item.titleUrl || '',
    };
  }

  get proiorModelDashBoardCardProps(): TDashboardCardData | undefined {
    const priorModels = this.itemData?.fields?.priorModels;
    if (!priorModels) return undefined;
    return {
      description: priorModels.description,
      title: priorModels.title,
      editorialImageProps: {
        desktopImage: priorModels.image,
        mobileImage: priorModels.mobileImage,
        alt: (priorModels.image?.value?.alt || priorModels.mobileImage?.value?.alt || '') as string,
      },
      titleUrl: priorModels.titleUrl || '',
    };
  }

  getCanShowPriorModelCard(isEE: boolean): boolean {
    if (isEE) return true;
    const { description, title, editorialImageProps } = this.proiorModelDashBoardCardProps || {};
    if (
      description?.value ||
      title?.value ||
      (editorialImageProps?.desktopImage as TImageField)?.value?.src ||
      (editorialImageProps?.mobileImage as TImageField)?.value?.src
    ) {
      return true;
    }
    return false;
  }
}
